'use strict';

// Services
import { arrayLoop } from 'services/array';

export const ratingsMap = {
  1: `1`,
  2: `2`,
  3: `3`,
  4: `4`,
  5: `5`,
  6: `5`,
  7: `5`,
  8: `8`,
  9: `9`,
  10: `10`,
};

export const statusMap = {
  1: `Started`,
  2: `Waiting for dentist upload`,
  3: `X-rays uploaded`,
  4: `Review complete`,
  5: `Validated`,
  6: `Rejected`,
};

const ratingItems = [];

arrayLoop(ratingsMap, (i) => {
  ratingItems.push({
    option: `${i}`,
    value: parseInt(i, 10),
  });
});

export const fields = {
  reviewer: {
    was_rubber_dam_used: {
      label: `Rubber Dam Used`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    conservative_access_prep: {
      label: `Conservative Access Prep`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    all_canal_cleaned_and_shaped: {
      label: `All Canals Cleaned and Shaped`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    canal_cleaned_and_shaped: {
      label: `Canals Cleaned and Shaped to the Apex`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    adequate_root_density: {
      label: `Adequate root filling density`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    perforation: {
      label: `Signs of perforation`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    separated_instrument: {
      label: `Signs of separated instrument`,
      type: `radio`,
      items: [
        {
          option: `Yes`,
          value: 1,
        },
        {
          option: `No`,
          value: 2,
        },
        {
          option: `Unable to tell`,
          value: 3,
        },
      ],
      validations: {
        required: true,
      },
    },
    rating: {
      intro: {
        copy: `Based on what you see and the AAE criteria, on a scale of 1-10 what is the likelihood this tooth will need re-treatment?
        <br>
        <br>
        1 = It likely needs extraction based on damage 
        <br>
        <br>
        5 = Will likely need retreatment
        <br>
        <br>
        10 = Good quality and should be fine
        <br>
        <br>
        Please only review based on the evidence in the radiographs submitted.  While we know that radiographs don't show everything and there may be unseen issues like missed canals, unless there is clear evidence of an issue, please assume that it is not a problem.`,
        size: `small`,
      },
      type: `radio`,
      items: ratingItems,
      validations: {
        required: true,
      },
    },
    reviewer_notes: {
      type: `textarea`,
      label: `Notes`,
      labelHidden: true,
      placeholder: `Please provide any additional comments`,
    },
  },
};



// WEBPACK FOOTER //
// ./client/models/review.js